'use strict';
var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
console.log('%c DPlayer 1.4.2 %c http://dplayer.js.org ', 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
require('./DPlayer.scss');
var utils = require('./utils.js');
var svg = require('./svg.js');
var handleOption = require('./option.js');
var i18n = require('./i18n.js');
var html = require('./html.js');
var Video = require('./video.js');
var isMobile = /mobile/i.test(window.navigator.userAgent);
var index = 0;
var DPlayer = function () {
    function DPlayer(option) {
        var _this = this;
        _classCallCheck(this, DPlayer);
        this.option = handleOption(option);
        this.option.element.classList.add('dplayer');
        if (this.option.video.quality) {
            this.qualityIndex = this.option.video.defaultQuality;
            this.quality = this.option.video.quality[this.option.video.defaultQuality];
        }
        this.tran = new i18n(this.option.lang).tran;
        this.updateBar = function (type, percentage, direction) {
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            bar[type + 'Bar'].style[direction] = percentage * 100 + '%';
        };
        var eventTypes = [
            'play',
            'pause',
            'canplay',
            'playing',
            'ended',
            'error'
        ];
        this.event = {};
        for (var i = 0; i < eventTypes.length; i++) {
            this.event[eventTypes[i]] = [];
        }
        this.trigger = function (type) {
            for (var _i = 0; _i < _this.event[type].length; _i++) {
                _this.event[type][_i]();
            }
        };
        this.element = this.option.element;
        if (!this.option.danmaku) {
            this.element.classList.add('dplayer-no-danmaku');
        }
        if (isMobile) {
            this.element.classList.add('dplayer-mobile');
        }
        this.element.innerHTML = html.main(option, index, this.tran);
        this.arrow = this.element.offsetWidth <= 500;
        if (this.arrow) {
            var arrowStyle = document.createElement('style');
            arrowStyle.innerHTML = '.dplayer .dplayer-danmaku{font-size:18px}';
            document.head.appendChild(arrowStyle);
        }
        this.video = new Video(this.element.getElementsByClassName('dplayer-video-current'));
        this.initVideo();
        this.bezel = this.element.getElementsByClassName('dplayer-bezel-icon')[0];
        this.bezel.addEventListener('animationend', function () {
            _this.bezel.classList.remove('dplayer-bezel-transition');
        });
        this.playButton = this.element.getElementsByClassName('dplayer-play-icon')[0];
        this.paused = true;
        this.playButton.addEventListener('click', function () {
            _this.toggle();
        });
        var videoWrap = this.element.getElementsByClassName('dplayer-video-wrap')[0];
        var conMask = this.element.getElementsByClassName('dplayer-controller-mask')[0];
        if (!isMobile) {
            videoWrap.addEventListener('click', function () {
                _this.toggle();
            });
            conMask.addEventListener('click', function () {
                _this.toggle();
            });
        } else {
            var toggleController = function toggleController() {
                if (_this.element.classList.contains('dplayer-hide-controller')) {
                    _this.element.classList.remove('dplayer-hide-controller');
                } else {
                    _this.element.classList.add('dplayer-hide-controller');
                }
            };
            videoWrap.addEventListener('click', toggleController);
            conMask.addEventListener('click', toggleController);
        }
        var bar = {};
        bar.playedBar = this.element.getElementsByClassName('dplayer-played')[0];
        bar.loadedBar = this.element.getElementsByClassName('dplayer-loaded')[0];
        var pbar = this.element.getElementsByClassName('dplayer-bar-wrap')[0];
        var pbarTimeTips = this.element.getElementsByClassName('dplayer-bar-time')[0];
        var barWidth = void 0;
        var lastPlayPos = 0;
        var currentPlayPos = 0;
        var bufferingDetected = false;
        this.danmakuTime = false;
        this.playedTime = false;
        this.animationFrame = function () {
            if (_this.playedTime) {
                currentPlayPos = _this.video.currentTime();
                if (!bufferingDetected && currentPlayPos < lastPlayPos + 0.001 && !_this.video.attr('paused')) {
                    _this.element.classList.add('dplayer-loading');
                    bufferingDetected = true;
                }
                if (bufferingDetected && currentPlayPos > lastPlayPos + 0.001 && !_this.video.attr('paused')) {
                    _this.element.classList.remove('dplayer-loading');
                    bufferingDetected = false;
                }
                lastPlayPos = currentPlayPos;
                _this.updateBar('played', _this.video.currentTime() / _this.video.duration, 'width');
                _this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = utils.secondToTime(_this.video.currentTime());
                _this.trigger('playing');
            }
            if (_this.danmakuTime && _this.option.danmaku && showdan && _this.dan) {
                var item = _this.dan[_this.danIndex];
                var danmakus = [];
                while (item && _this.video.currentTime() > parseFloat(item.time)) {
                    danmakus.push(item);
                    item = _this.dan[++_this.danIndex];
                }
                _this.pushDanmaku(danmakus);
            }
            requestAnimationFrame(_this.animationFrame);
        };
        requestAnimationFrame(this.animationFrame);
        this.setTime = function (type) {
            if (!type) {
                _this.danmakuTime = true;
                _this.playedTime = true;
            } else {
                _this[type + 'Time'] = true;
            }
        };
        this.clearTime = function (type) {
            if (!type) {
                _this.danmakuTime = false;
                _this.playedTime = false;
            } else {
                _this[type + 'Time'] = false;
            }
        };
        pbar.addEventListener('click', function (event) {
            var e = event || window.event;
            barWidth = pbar.clientWidth;
            var percentage = (e.clientX - utils.getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.video.seek(parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration);
        });
        this.isTipsShow = false;
        this.timeTipsHandler = this.timeTipsHandler(pbar, pbarTimeTips).bind(this);
        pbar.addEventListener('mousemove', this.timeTipsHandler);
        pbar.addEventListener('mouseover', this.timeTipsHandler);
        pbar.addEventListener('mouseenter', this.timeTipsHandler);
        pbar.addEventListener('mouseout', this.timeTipsHandler);
        pbar.addEventListener('mouseleave', this.timeTipsHandler);
        var thumbMove = function thumbMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - utils.getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = utils.secondToTime(percentage * _this.video.duration);
        };
        var thumbUp = function thumbUp() {
            document.removeEventListener('mouseup', thumbUp);
            document.removeEventListener('mousemove', thumbMove);
            _this.video.seek(parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration);
            _this.setTime();
        };
        pbar.addEventListener('mousedown', function () {
            barWidth = pbar.clientWidth;
            _this.clearTime();
            document.addEventListener('mousemove', thumbMove);
            document.addEventListener('mouseup', thumbUp);
        });
        bar.volumeBar = this.element.getElementsByClassName('dplayer-volume-bar-inner')[0];
        var volumeEle = this.element.getElementsByClassName('dplayer-volume')[0];
        var volumeBarWrapWrap = this.element.getElementsByClassName('dplayer-volume-bar-wrap')[0];
        var volumeBarWrap = this.element.getElementsByClassName('dplayer-volume-bar')[0];
        var volumeicon = this.element.getElementsByClassName('dplayer-volume-icon')[0];
        var vWidth = 35;
        this.switchVolumeIcon = function () {
            var volumeicon = _this.element.getElementsByClassName('dplayer-volume-icon')[0];
            if (_this.video.attr('volume') >= 0.8) {
                volumeicon.innerHTML = svg('volume-up');
            } else if (_this.video.attr('volume') > 0) {
                volumeicon.innerHTML = svg('volume-down');
            } else {
                volumeicon.innerHTML = svg('volume-off');
            }
        };
        var volumeMove = function volumeMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - utils.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        };
        var volumeUp = function volumeUp() {
            document.removeEventListener('mouseup', volumeUp);
            document.removeEventListener('mousemove', volumeMove);
            volumeEle.classList.remove('dplayer-volume-active');
        };
        volumeBarWrapWrap.addEventListener('click', function (event) {
            var e = event || window.event;
            var percentage = (e.clientX - utils.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        });
        volumeBarWrapWrap.addEventListener('mousedown', function () {
            document.addEventListener('mousemove', volumeMove);
            document.addEventListener('mouseup', volumeUp);
            volumeEle.classList.add('dplayer-volume-active');
        });
        volumeicon.addEventListener('click', function () {
            if (_this.video.attr('muted')) {
                _this.video.attr('muted', false);
                _this.switchVolumeIcon();
                _this.updateBar('volume', _this.video.attr('volume'), 'width');
            } else {
                _this.video.attr('muted', true);
                volumeicon.innerHTML = svg('volume-off');
                _this.updateBar('volume', 0, 'width');
            }
        });
        var hideTime = 0;
        if (!isMobile) {
            var hideController = function hideController() {
                _this.element.classList.remove('dplayer-hide-controller');
                clearTimeout(hideTime);
                hideTime = setTimeout(function () {
                    if (_this.video.attr('played').length) {
                        _this.element.classList.add('dplayer-hide-controller');
                        closeSetting();
                        closeComment();
                    }
                }, 2000);
            };
            this.element.addEventListener('mousemove', hideController);
            this.element.addEventListener('click', hideController);
        }
        this.danOpacity = localStorage.getItem('DPlayer-opacity') || 0.7;
        var settingHTML = html.setting(this.tran);
        var settingIcon = this.element.getElementsByClassName('dplayer-setting-icon')[0];
        var settingBox = this.element.getElementsByClassName('dplayer-setting-box')[0];
        var mask = this.element.getElementsByClassName('dplayer-mask')[0];
        settingBox.innerHTML = settingHTML.original;
        var closeSetting = function closeSetting() {
            if (settingBox.classList.contains('dplayer-setting-box-open')) {
                settingBox.classList.remove('dplayer-setting-box-open');
                mask.classList.remove('dplayer-mask-show');
                setTimeout(function () {
                    settingBox.classList.remove('dplayer-setting-box-narrow');
                    settingBox.innerHTML = settingHTML.original;
                    settingEvent();
                }, 300);
            }
        };
        var openSetting = function openSetting() {
            settingBox.classList.add('dplayer-setting-box-open');
            mask.classList.add('dplayer-mask-show');
        };
        mask.addEventListener('click', function () {
            closeSetting();
        });
        settingIcon.addEventListener('click', function () {
            openSetting();
        });
        this.loop = this.option.loop;
        var danContainer = this.element.getElementsByClassName('dplayer-danmaku')[0];
        var showdan = true;
        var settingEvent = function settingEvent() {
            var loopEle = _this.element.getElementsByClassName('dplayer-setting-loop')[0];
            var loopToggle = loopEle.getElementsByClassName('dplayer-toggle-setting-input')[0];
            loopToggle.checked = _this.loop;
            loopEle.addEventListener('click', function () {
                loopToggle.checked = !loopToggle.checked;
                if (loopToggle.checked) {
                    _this.loop = true;
                } else {
                    _this.loop = false;
                }
                closeSetting();
            });
            var showDanEle = _this.element.getElementsByClassName('dplayer-setting-showdan')[0];
            var showDanToggle = showDanEle.getElementsByClassName('dplayer-showdan-setting-input')[0];
            showDanToggle.checked = showdan;
            showDanEle.addEventListener('click', function () {
                showDanToggle.checked = !showDanToggle.checked;
                if (showDanToggle.checked) {
                    showdan = true;
                    if (_this.option.danmaku) {
                        for (var _i2 = 0; _i2 < _this.dan.length; _i2++) {
                            if (_this.dan[_i2].time >= _this.video.currentTime()) {
                                _this.danIndex = _i2;
                                break;
                            }
                            _this.danIndex = _this.dan.length;
                        }
                        if (!_this.paused) {
                            _this.setTime('danmaku');
                        }
                    }
                } else {
                    showdan = false;
                    if (_this.option.danmaku) {
                        _this.clearTime('danmaku');
                        danContainer.innerHTML = '';
                        _this.danTunnel = {
                            right: {},
                            top: {},
                            bottom: {}
                        };
                    }
                }
                closeSetting();
            });
            var speedEle = _this.element.getElementsByClassName('dplayer-setting-speed')[0];
            speedEle.addEventListener('click', function () {
                settingBox.classList.add('dplayer-setting-box-narrow');
                settingBox.innerHTML = settingHTML.speed;
                var speedItem = settingBox.getElementsByClassName('dplayer-setting-speed-item');
                var _loop = function _loop(_i3) {
                    speedItem[_i3].addEventListener('click', function () {
                        _this.video.attr('playbackRate', speedItem[_i3].dataset.speed);
                        closeSetting();
                    });
                };
                for (var _i3 = 0; _i3 < speedItem.length; _i3++) {
                    _loop(_i3);
                }
            });
            if (_this.option.danmaku) {
                bar.danmakuBar = _this.element.getElementsByClassName('dplayer-danmaku-bar-inner')[0];
                var danmakuBarWrapWrap = _this.element.getElementsByClassName('dplayer-danmaku-bar-wrap')[0];
                var danmakuBarWrap = _this.element.getElementsByClassName('dplayer-danmaku-bar')[0];
                var danmakuSettingBox = _this.element.getElementsByClassName('dplayer-setting-danmaku')[0];
                var dWidth = 130;
                _this.updateBar('danmaku', _this.danOpacity, 'width');
                var danmakuMove = function danmakuMove(event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - utils.getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.updateBar('danmaku', percentage, 'width');
                    var items = _this.element.getElementsByClassName('dplayer-danmaku-item');
                    for (var _i4 = 0; _i4 < items.length; _i4++) {
                        items[_i4].style.opacity = percentage;
                    }
                    _this.danOpacity = percentage;
                    localStorage.setItem('DPlayer-opacity', _this.danOpacity);
                };
                var danmakuUp = function danmakuUp() {
                    document.removeEventListener('mouseup', danmakuUp);
                    document.removeEventListener('mousemove', danmakuMove);
                    danmakuSettingBox.classList.remove('dplayer-setting-danmaku-active');
                };
                danmakuBarWrapWrap.addEventListener('click', function (event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - utils.getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.updateBar('danmaku', percentage, 'width');
                    var items = _this.element.getElementsByClassName('dplayer-danmaku-item');
                    for (var _i5 = 0; _i5 < items.length; _i5++) {
                        items[_i5].style.opacity = percentage;
                    }
                    _this.danOpacity = percentage;
                    localStorage.setItem('DPlayer-opacity', _this.danOpacity);
                });
                danmakuBarWrapWrap.addEventListener('mousedown', function () {
                    document.addEventListener('mousemove', danmakuMove);
                    document.addEventListener('mouseup', danmakuUp);
                    danmakuSettingBox.classList.add('dplayer-setting-danmaku-active');
                });
            }
        };
        settingEvent();
        if (this.video.duration !== 1) {
            this.element.getElementsByClassName('dplayer-dtime')[0].innerHTML = this.video.duration ? utils.secondToTime(this.video.duration) : '00:00';
        }
        this.danTunnel = {
            right: {},
            top: {},
            bottom: {}
        };
        var measureStyle = getComputedStyle(this.element.getElementsByClassName('dplayer-danmaku-item')[0], null);
        var context = document.createElement('canvas').getContext('2d');
        context.font = measureStyle.getPropertyValue('font-size') + ' ' + measureStyle.getPropertyValue('font-family');
        this.danmakuMeasure = function (text) {
            return context.measureText(text).width;
        };
        if (this.option.danmaku) {
            this.danIndex = 0;
            this.readDanmaku();
        } else {
            if (this.option.autoplay && !isMobile) {
                this.play();
            } else if (isMobile) {
                this.pause();
            }
        }
        var commentInput = this.element.getElementsByClassName('dplayer-comment-input')[0];
        var commentIcon = this.element.getElementsByClassName('dplayer-comment-icon')[0];
        var commentBox = this.element.getElementsByClassName('dplayer-comment-box')[0];
        var commentSettingIcon = this.element.getElementsByClassName('dplayer-comment-setting-icon')[0];
        var commentSettingBox = this.element.getElementsByClassName('dplayer-comment-setting-box')[0];
        var commentSendIcon = this.element.getElementsByClassName('dplayer-send-icon')[0];
        var htmlEncode = function htmlEncode(str) {
            return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g, '&#x2f;');
        };
        var sendComment = function sendComment() {
            commentInput.blur();
            if (!commentInput.value.replace(/^\s+|\s+$/g, '')) {
                _this.notice(_this.tran('Please input danmaku content!'));
                return;
            }
            var danmakuData = {
                token: _this.option.danmaku.token,
                player: _this.option.danmaku.id,
                author: _this.option.danmaku.user,
                time: _this.video.currentTime(),
                text: commentInput.value,
                color: _this.element.querySelector('.dplayer-comment-setting-color input:checked').value,
                type: _this.element.querySelector('.dplayer-comment-setting-type input:checked').value
            };
            _this.option.apiBackend.send(_this.option.danmaku.api, danmakuData);
            commentInput.value = '';
            closeComment();
            _this.dan.splice(_this.danIndex, 0, danmakuData);
            _this.danIndex++;
            var danmaku = {
                text: htmlEncode(danmakuData.text),
                color: danmakuData.color,
                type: danmakuData.type,
                border: '2px solid ' + _this.option.theme
            };
            _this.pushDanmaku(danmaku);
        };
        var closeCommentSetting = function closeCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            }
        };
        var toggleCommentSetting = function toggleCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            } else {
                commentSettingBox.classList.add('dplayer-comment-setting-open');
            }
        };
        var disableHide = 0;
        var commentFocusTimeout = 0;
        var closeComment = function closeComment() {
            if (!commentBox.classList.contains('dplayer-comment-box-open')) {
                return;
            }
            commentBox.classList.remove('dplayer-comment-box-open');
            mask.classList.remove('dplayer-mask-show');
            _this.element.classList.remove('dplayer-show-controller');
            clearInterval(disableHide);
            clearTimeout(commentFocusTimeout);
            closeCommentSetting();
        };
        var openComment = function openComment() {
            if (commentBox.classList.contains('dplayer-comment-box-open')) {
                return;
            }
            commentBox.classList.add('dplayer-comment-box-open');
            mask.classList.add('dplayer-mask-show');
            _this.element.classList.add('dplayer-show-controller');
            disableHide = setInterval(function () {
                clearTimeout(hideTime);
            }, 1000);
            commentFocusTimeout = setTimeout(function () {
                commentInput.focus();
            }, 300);
        };
        mask.addEventListener('click', function () {
            closeComment();
        });
        commentIcon.addEventListener('click', function () {
            openComment();
        });
        commentSettingIcon.addEventListener('click', function () {
            toggleCommentSetting();
        });
        this.element.getElementsByClassName('dplayer-comment-setting-color')[0].addEventListener('click', function () {
            var sele = _this.element.querySelector('input[name="dplayer-danmaku-color-${index}"]:checked+span');
            if (sele) {
                commentSettingIcon.getElementsByClassName('dplayer-fill')[0].style.fill = _this.element.querySelector('input[name="dplayer-danmaku-color-${index}"]:checked').value;
            }
        });
        commentInput.addEventListener('click', function () {
            closeCommentSetting();
        });
        commentInput.addEventListener('keydown', function (e) {
            var event = e || window.event;
            if (event.keyCode === 13) {
                sendComment();
            }
        });
        commentSendIcon.addEventListener('click', sendComment);
        var resetAnimation = function resetAnimation() {
            var danWidth = danContainer.offsetWidth;
            var items = _this.element.getElementsByClassName('dplayer-danmaku-item');
            for (var _i6 = 0; _i6 < items.length; _i6++) {
                items[_i6].style.transform = 'translateX(-' + danWidth + 'px)';
            }
        };
        this.element.addEventListener('fullscreenchange', function () {
            resetAnimation();
        });
        this.element.addEventListener('mozfullscreenchange', function () {
            resetAnimation();
        });
        this.element.addEventListener('webkitfullscreenchange', function () {
            resetAnimation();
        });
        this.element.getElementsByClassName('dplayer-full-icon')[0].addEventListener('click', function () {
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                if (_this.element.requestFullscreen) {
                    _this.element.requestFullscreen();
                } else if (_this.element.mozRequestFullScreen) {
                    _this.element.mozRequestFullScreen();
                } else if (_this.element.webkitRequestFullscreen) {
                    _this.element.webkitRequestFullscreen();
                } else if (_this.video.attr('webkitEnterFullscreen')) {
                    _this.video.current.webkitEnterFullscreen();
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
            resetAnimation();
        });
        this.element.getElementsByClassName('dplayer-full-in-icon')[0].addEventListener('click', function () {
            if (_this.element.classList.contains('dplayer-fulled')) {
                _this.element.classList.remove('dplayer-fulled');
            } else {
                _this.element.classList.add('dplayer-fulled');
                resetAnimation();
            }
        });
        var handleKeyDown = function handleKeyDown(e) {
            var tag = document.activeElement.tagName.toUpperCase();
            var editable = document.activeElement.getAttribute('contenteditable');
            if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
                var event = e || window.event;
                var percentage = void 0;
                switch (event.keyCode) {
                case 32:
                    event.preventDefault();
                    _this.toggle();
                    break;
                case 37:
                    event.preventDefault();
                    _this.video.seek(_this.video.currentTime() - 5);
                    break;
                case 39:
                    event.preventDefault();
                    _this.video.seek(_this.video.currentTime() + 5);
                    break;
                case 38:
                    event.preventDefault();
                    percentage = _this.video.attr('volume') + 0.1;
                    _this.volume(percentage);
                    break;
                case 40:
                    event.preventDefault();
                    percentage = _this.video.attr('volume') - 0.1;
                    _this.volume(percentage);
                    break;
                }
            }
        };
        if (this.option.hotkey) {
            document.addEventListener('keydown', handleKeyDown);
        }
        document.addEventListener('keydown', function (e) {
            var event = e || window.event;
            switch (event.keyCode) {
            case 27:
                if (_this.element.classList.contains('dplayer-fulled')) {
                    _this.element.classList.remove('dplayer-fulled');
                    resetAnimation();
                }
                break;
            }
        });
        var menu = this.element.getElementsByClassName('dplayer-menu')[0];
        this.element.addEventListener('contextmenu', function (e) {
            var event = e || window.event;
            event.preventDefault();
            menu.classList.add('dplayer-menu-show');
            var clientRect = _this.element.getBoundingClientRect();
            var menuLeft = event.clientX - clientRect.left;
            var menuTop = event.clientY - clientRect.top;
            if (menuLeft + menu.offsetWidth >= clientRect.width) {
                menu.style.right = clientRect.width - menuLeft + 'px';
                menu.style.left = 'initial';
            } else {
                menu.style.left = event.clientX - _this.element.getBoundingClientRect().left + 'px';
                menu.style.right = 'initial';
            }
            if (menuTop + menu.offsetHeight >= clientRect.height) {
                menu.style.bottom = clientRect.height - menuTop + 'px';
                menu.style.top = 'initial';
            } else {
                menu.style.top = event.clientY - _this.element.getBoundingClientRect().top + 'px';
                menu.style.bottom = 'initial';
            }
            mask.classList.add('dplayer-mask-show');
            mask.addEventListener('click', function () {
                mask.classList.remove('dplayer-mask-show');
                menu.classList.remove('dplayer-menu-show');
            });
        });
        if (this.option.video.quality) {
            this.element.getElementsByClassName('dplayer-quality-list')[0].addEventListener('click', function (e) {
                if (e.target.classList.contains('dplayer-quality-item')) {
                    _this.switchQuality(e.target.dataset.index);
                }
            });
        }
        if (this.option.screenshot) {
            var camareIcon = this.element.getElementsByClassName('dplayer-camera-icon')[0];
            camareIcon.addEventListener('click', function () {
                var canvas = document.createElement('canvas');
                canvas.width = _this.video.attr('videoWidth');
                canvas.height = _this.video.attr('videoHeight');
                canvas.getContext('2d').drawImage(_this.video.current, 0, 0, canvas.width, canvas.height);
                camareIcon.href = canvas.toDataURL();
                camareIcon.download = 'DPlayer.png';
            });
        }
        index++;
    }
    _createClass(DPlayer, [
        {
            key: 'play',
            value: function play(time) {
                if (Object.prototype.toString.call(time) === '[object Number]') {
                    this.video.seek(time);
                }
                this.paused = false;
                if (this.video.attr('paused')) {
                    this.bezel.innerHTML = svg('play');
                    this.bezel.classList.add('dplayer-bezel-transition');
                }
                this.playButton.innerHTML = svg('pause');
                this.video.play();
                this.setTime();
                this.element.classList.add('dplayer-playing');
                this.trigger('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
                this.element.classList.remove('dplayer-loading');
                if (!this.video.attr('paused')) {
                    this.bezel.innerHTML = svg('pause');
                    this.bezel.classList.add('dplayer-bezel-transition');
                }
                this.ended = false;
                this.playButton.innerHTML = svg('play');
                this.video.pause();
                this.clearTime();
                this.element.classList.remove('dplayer-playing');
                this.trigger('pause');
            }
        },
        {
            key: 'volume',
            value: function volume(percentage) {
                percentage = percentage > 0 ? percentage : 0;
                percentage = percentage < 1 ? percentage : 1;
                this.updateBar('volume', percentage, 'width');
                this.video.attr('volume', percentage);
                if (this.video.attr('muted')) {
                    this.video.attr('muted', false);
                }
                this.switchVolumeIcon();
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.video.attr('paused')) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        },
        {
            key: 'on',
            value: function on(event, callback) {
                if (typeof callback === 'function') {
                    this.event[event].push(callback);
                }
            }
        },
        {
            key: '_readAllEndpoints',
            value: function _readAllEndpoints(endpoints, finish) {
                var _this2 = this;
                var results = [];
                var readCount = 0;
                var cbk = function cbk(i) {
                    return function (err, data) {
                        ++readCount;
                        if (err) {
                            if (err.response) {
                                _this2.notice(err.response.msg);
                            } else {
                                _this2.notice('Request was unsuccessful: ' + err.status);
                            }
                            results[i] = [];
                        } else {
                            results[i] = data;
                        }
                        if (readCount === endpoints.length) {
                            return finish(results);
                        }
                    };
                };
                for (var i = 0; i < endpoints.length; ++i) {
                    this.option.apiBackend.read(endpoints[i], cbk(i));
                }
            }
        },
        {
            key: 'readDanmaku',
            value: function readDanmaku() {
                var _this3 = this;
                var isMobile = /mobile/i.test(window.navigator.userAgent);
                var apiurl = void 0;
                if (this.option.danmaku.maximum) {
                    apiurl = this.option.danmaku.api + '?id=' + this.option.danmaku.id + '&max=' + this.option.danmaku.maximum;
                } else {
                    apiurl = this.option.danmaku.api + '?id=' + this.option.danmaku.id;
                }
                var endpoints = (this.option.danmaku.addition || []).slice(0);
                endpoints.push(apiurl);
                this._readAllEndpoints(endpoints, function (results) {
                    _this3.danIndex = 0;
                    _this3.dan = [].concat.apply([], results).sort(function (a, b) {
                        return a.time - b.time;
                    });
                    _this3.element.getElementsByClassName('dplayer-danloading')[0].style.display = 'none';
                    if (_this3.option.autoplay && !isMobile) {
                        _this3.play();
                    } else if (isMobile) {
                        _this3.pause();
                    }
                });
            }
        },
        {
            key: 'pushDanmaku',
            value: function pushDanmaku(danmaku) {
                var _this4 = this;
                var danContainer = this.element.getElementsByClassName('dplayer-danmaku')[0];
                var itemHeight = this.arrow ? 24 : 30;
                var danWidth = danContainer.offsetWidth;
                var danHeight = danContainer.offsetHeight;
                var itemY = parseInt(danHeight / itemHeight);
                var danItemRight = function danItemRight(ele) {
                    var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                    var eleRight = ele.getBoundingClientRect().right || danContainer.getBoundingClientRect().right + eleWidth;
                    return danContainer.getBoundingClientRect().right - eleRight;
                };
                var danSpeed = function danSpeed(width) {
                    return (danWidth + width) / 5;
                };
                var getTunnel = function getTunnel(ele, type, width) {
                    var tmp = danWidth / danSpeed(width);
                    var _loop2 = function _loop2(i) {
                        var item = _this4.danTunnel[type][i + ''];
                        if (item && item.length) {
                            for (var j = 0; j < item.length; j++) {
                                var danRight = danItemRight(item[j]) - 10;
                                if (danRight <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danRight <= 0) {
                                    break;
                                }
                                if (j === item.length - 1) {
                                    _this4.danTunnel[type][i + ''].push(ele);
                                    ele.addEventListener('animationend', function () {
                                        _this4.danTunnel[type][i + ''].splice(0, 1);
                                    });
                                    return { v: i % itemY };
                                }
                            }
                        } else {
                            _this4.danTunnel[type][i + ''] = [ele];
                            ele.addEventListener('animationend', function () {
                                _this4.danTunnel[type][i + ''].splice(0, 1);
                            });
                            return { v: i % itemY };
                        }
                    };
                    for (var i = 0;; i++) {
                        var _ret2 = _loop2(i);
                        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === 'object')
                            return _ret2.v;
                    }
                };
                if (Object.prototype.toString.call(danmaku) !== '[object Array]') {
                    danmaku = [danmaku];
                }
                var docFragment = document.createDocumentFragment();
                var _loop3 = function _loop3(i) {
                    if (!danmaku[i].type) {
                        danmaku[i].type = 'right';
                    }
                    if (!danmaku[i].color) {
                        danmaku[i].color = '#fff';
                    }
                    var item = document.createElement('div');
                    item.classList.add('dplayer-danmaku-item');
                    item.classList.add('dplayer-danmaku-' + danmaku[i].type);
                    item.innerHTML = danmaku[i].text;
                    item.style.opacity = _this4.danOpacity;
                    item.style.color = danmaku[i].color;
                    item.style.border = danmaku[i].border;
                    item.addEventListener('animationend', function () {
                        danContainer.removeChild(item);
                    });
                    var itemWidth = _this4.danmakuMeasure(danmaku[i].text);
                    switch (danmaku[i].type) {
                    case 'right':
                        item.style.width = itemWidth + 1 + 'px';
                        item.style.top = itemHeight * getTunnel(item, danmaku[i].type, itemWidth) + 'px';
                        item.style.transform = 'translateX(-' + danWidth + 'px)';
                        break;
                    case 'top':
                        item.style.top = itemHeight * getTunnel(item, danmaku[i].type) + 'px';
                        break;
                    case 'bottom':
                        item.style.bottom = itemHeight * getTunnel(item, danmaku[i].type) + 'px';
                        break;
                    default:
                        console.error('Can\'t handled danmaku type: ' + danmaku[i].type);
                    }
                    item.classList.add('dplayer-danmaku-move');
                    docFragment.appendChild(item);
                };
                for (var i = 0; i < danmaku.length; i++) {
                    _loop3(i);
                }
                danContainer.appendChild(docFragment);
                return docFragment;
            }
        },
        {
            key: 'switchVideo',
            value: function switchVideo(video, danmaku) {
                this.video.attr('poster', video.pic ? video.pic : '');
                this.video.attr('src', video.url);
                this.pause();
                if (danmaku) {
                    this.dan = [];
                    this.danIndex = 0;
                    this.element.getElementsByClassName('dplayer-danloading')[0].style.display = 'block';
                    this.updateBar('played', 0, 'width');
                    this.updateBar('loaded', 0, 'width');
                    this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = '00:00';
                    this.element.getElementsByClassName('dplayer-danmaku')[0].innerHTML = '';
                    this.danTuel = {
                        right: {},
                        top: {},
                        bottom: {}
                    };
                    this.option.danmaku = danmaku;
                    this.readDanmaku();
                }
            }
        },
        {
            key: 'initVideo',
            value: function initVideo() {
                var _this5 = this;
                var enablehls = void 0;
                if (this.option.video.type === 'auto') {
                    enablehls = /m3u8(#|\?|$)/i.exec(this.option.video.url);
                } else if (this.option.video.type === 'hls') {
                    enablehls = true;
                } else {
                    enablehls = false;
                }
                if (enablehls && Hls.isSupported()) {
                    var hls = new Hls();
                    hls.attachMedia(this.video.current);
                    hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                        hls.loadSource(_this5.option.video.url);
                        hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                            this.notice('manifest loaded, found ' + data.levels.length + ' quality level');
                        });
                    });
                }
                var enableflv = void 0;
                if (this.option.video.type === 'auto') {
                    enableflv = /.flv(#|\?|$)/i.exec(this.option.video.url);
                } else if (this.option.video.type === 'flv') {
                    enableflv = true;
                } else {
                    enableflv = false;
                }
                if (enableflv && flvjs.isSupported()) {
                    var flvPlayer = flvjs.createPlayer({
                        type: 'flv',
                        url: this.option.video.url
                    });
                    flvPlayer.attachMediaElement(this.video.current);
                    flvPlayer.load();
                }
                if (this.option.danmaku) {
                    this.video.on('all', 'seeking', function () {
                        for (var i = 0; i < _this5.dan.length; i++) {
                            if (_this5.dan[i].time >= _this5.video.currentTime()) {
                                _this5.danIndex = i;
                                return;
                            }
                            _this5.danIndex = _this5.dan.length;
                        }
                    });
                }
                this.video.on('all', 'durationchange', function (i, video) {
                    if (video.duration !== 1) {
                        _this5.element.getElementsByClassName('dplayer-dtime')[0].innerHTML = utils.secondToTime(_this5.video.duration);
                    }
                });
                this.video.on('current', 'progress', function (i, video) {
                    var percentage = video.buffered.length ? video.buffered.end(video.buffered.length - 1) / video.duration : 0;
                    _this5.updateBar('loaded', percentage, 'width');
                });
                this.video.on('all', 'error', function () {
                    _this5.notice(_this5.tran('This video fails to load'), -1);
                    _this5.trigger('pause');
                });
                this.video.on('current', 'canplay', function () {
                    _this5.trigger('canplay');
                });
                this.ended = false;
                this.video.on('all', 'ended', function (i) {
                    if (i === _this5.video.videos.length - 1) {
                        _this5.updateBar('played', 1, 'width');
                        if (!_this5.loop) {
                            _this5.ended = true;
                            _this5.pause();
                            _this5.trigger('ended');
                        } else {
                            _this5.video.switch(0);
                            _this5.video.play();
                        }
                        _this5.danIndex = 0;
                    }
                });
                this.video.on('current', 'play', function () {
                    if (_this5.paused) {
                        _this5.play();
                    }
                });
                this.video.on('current', 'pause', function () {
                    if (!_this5.paused) {
                        _this5.pause();
                    }
                });
                this.video.attr('volume', parseInt(this.element.getElementsByClassName('dplayer-volume-bar-inner')[0].style.width) / 100);
            }
        },
        {
            key: 'switchQuality',
            value: function switchQuality(index) {
                var _this6 = this;
                if (this.qualityIndex === index || this.switchingQuality) {
                    return;
                } else {
                    this.qualityIndex = index;
                }
                this.switchingQuality = true;
                this.quality = this.option.video.quality[index];
                this.element.getElementsByClassName('dplayer-quality-icon')[0].innerHTML = this.quality.name;
                this.video.pause();
                var videoHTML = html.video(false, null, this.option.screenshot, 'auto', this.quality.url);
                var videoEle = new DOMParser().parseFromString(videoHTML, 'text/html').body.firstChild;
                var parent = this.element.getElementsByClassName('dplayer-video-wrap')[0];
                parent.insertBefore(videoEle, parent.getElementsByTagName('div')[0]);
                this.prevVideo = this.video;
                this.video = new Video([videoEle], this.prevVideo.duration);
                this.initVideo();
                this.video.seek(this.prevVideo.currentTime());
                this.notice(this.tran('Switching to') + ' ' + this.quality.name + ' ' + this.tran('quality'), -1);
                this.video.on('current', 'canplay', function () {
                    if (_this6.prevVideo) {
                        if (_this6.video.currentTime() !== _this6.prevVideo.currentTime()) {
                            _this6.video.seek(_this6.prevVideo.currentTime());
                            return;
                        }
                        parent.removeChild(_this6.prevVideo.current);
                        _this6.video.current.classList.add('dplayer-video-current');
                        _this6.video.play();
                        _this6.prevVideo = null;
                        _this6.notice(_this6.tran('Switched to') + ' ' + _this6.quality.name + ' ' + _this6.tran('quality'));
                        _this6.switchingQuality = false;
                    }
                });
            }
        },
        {
            key: 'timeTipsHandler',
            value: function timeTipsHandler(pbar, timeTips) {
                var _this7 = this;
                var cumulativeOffset = function cumulativeOffset(element) {
                    var top = 0, left = 0;
                    do {
                        top += element.offsetTop || 0;
                        left += element.offsetLeft || 0;
                        element = element.offsetParent;
                    } while (element);
                    return {
                        top: top,
                        left: left
                    };
                };
                return function (e) {
                    if (!_this7.video.duration) {
                        return;
                    }
                    var clientX = e.clientX;
                    var px = cumulativeOffset(pbar).left;
                    var tx = clientX - px;
                    timeTips.innerText = utils.secondToTime(_this7.video.duration * (tx / pbar.offsetWidth));
                    timeTips.style.left = tx - 20 + 'px';
                    switch (e.type) {
                    case 'mouseenter':
                    case 'mouseover':
                    case 'mousemove':
                        if (_this7.isTipsShow) {
                            return;
                        }
                        timeTips.classList.remove('hidden');
                        _this7.isTipsShow = true;
                        break;
                    case 'mouseleave':
                    case 'mouseout':
                        if (!_this7.isTipsShow) {
                            return;
                        }
                        timeTips.classList.add('hidden');
                        _this7.isTipsShow = false;
                        break;
                    }
                };
            }
        },
        {
            key: 'notice',
            value: function notice(text, time) {
                var noticeEle = this.element.getElementsByClassName('dplayer-notice')[0];
                noticeEle.innerHTML = text;
                noticeEle.style.opacity = 1;
                if (this.noticeTime) {
                    clearTimeout(this.noticeTime);
                }
                if (time && time < 0) {
                    return;
                }
                this.noticeTime = setTimeout(function () {
                    noticeEle.style.opacity = 0;
                }, time || 2000);
            }
        }
    ]);
    return DPlayer;
}();
module.exports = DPlayer;


//////////////////
// WEBPACK FOOTER
// ./src/DPlayer.js
// module id = 1
// module chunks = 0